export default __webpack_public_path__ + "static/media/donut-05.c372b28d.png";